
import React from 'react';

export default function NotificationBadge() {
    return (
        <div className="notification-badge"></div>
    )
}